export default [
    {
      text: "Basic",
      value: "Basic"
    },
    {
      text: "Basic With Oxygen",
      value: "Basic With Oxygen"
    },
    {
      text: "Cardiac",
      value: "Cardiac"
    },
    {
      text: "Hearse",
      value: "Hearse"
    },
    {
      text: "Air Ambulance",
      value: "Air Ambulance"
    },
    {
      text: "Motorcycle Ambulance",
      value: "Motorcycle Ambulance"
    }
  ];
  